<template>
	<div class="good-detail">
		<BlankView v-if="invalid" />
		<div class="good-detail__body" v-else>
			<div>
				<img
					@click.stop="showShare"
					:src="require('@/assets/imgs/goods/share.png')"
					class="share_btn global_pointer"
				/>
			</div>
			<div class="back global_pointer" @click="goBack">
				<img src="@/assets/imgs/back_white.png" />
			</div>
			<!-- banner -->
			<div class="banner-placeholder">
				<banner
					h5
					v-if="merchandiseResources.length || videoKey"
					:videoKey="videoKey"
					:data="merchandiseResources"
				/>
			</div>

			<div v-if="business" class="merchants-main">
				<Merchants class="merchants-box" :business="business" />
			</div>
			<!-- 商品 -->
			<GoodsInfo
				:minShelfAmountMoney = "minShelfAmountMoney"
				:miniAmountMoney="miniAmountMoney"
				:selfSupport="selfSupport"
				:userDiscountStr="userDiscountStr"
				:userDiscount="userDiscount"
				:miniOrgAmountMoney="miniOrgAmountMoney"
				:isFreeShipping="isFreeShipping"
				:isFreeTaxes="isFreeTaxes"
				:userLikeMdse="userLikeMdse"
				:mdseLikeNum="mdseLikeNum"
				:name="name"
				:hideAddCart="1"
				:salesNum="salesNum"
				:hidePrice="!showSeckill && !showAssemble"
				:supportRefund="supportRefund"
                :serviceFeeInfo="serviceFeeInfo"
				@collect="navToYYB"
			/>
			<!-- 商品属性 -->
			<IntroList
				:cityName="cityName"
				:serve="serve"
				:drections="drections"
				:skuText="skuText"
				:goodsId="id"
				@place-an-order="placeAnOrder"
			/>
			<!-- 店铺信息 -->
			<div>
				<store
					v-if="storeName"
					:storeBg="storeBg"
					:storeName="storeName"
					:storeCountry="storeCountry"
					:storeIdOnSaleNum="storeIdOnSaleNum"
					:storeId="storeId"
					:storeLogo="storeLogo"
				/>
			</div>

			<!-- 富文本 -->
			<RichText
				:description="description"
				:merchandiseResources="merchandiseResources"
			/>

			
			
		</div>
		<share
				v-if="shareShow"
				@shareClose="shareShow = false"
				sharePosition="GoodDetail"
				:shareInfo="shareInfo"
			></share>
    <FuncButtons
      class="good-detail__footer"
      v-if="name"
      :hideAddCart="0"
      :stock="stock"
      :lockStock="lockStock"
      :deleted="deleted"
      :showAppStatus="showAppStatus"
      :shelfStatus="shelfStatus"
      :goodsId="id"
      :netAccount="netAccount"
      @customer-service="customerService"
      @place-an-order="placeAnOrder"
      @addCart="addCart"
      @myWant="myWant"
    />
	</div>
</template>
<script>
import api from "@/api/api_list";
import BlankView from "@/components/goods/blankView";
import Banner from "@/components/goods/banner";
import Merchants from "@/components/goods/merchants";
import IntroList from "@/components/goods/introList";
import GoodsInfo from "@/components/goods/goodsInfo";
import Store from "@/components/goods/store";
import RichText from "@/components/goods/richText";
import FuncButtons from "@/components/goods/funcButtons";
import { plateForm } from "@/utils";
import share from "@/components/room/share";
import { priceSeparator } from "@/utils/formatUtil";
const isMiniApp = plateForm().os === "alipayMini";

const isZFB = plateForm().os === "alipayClient";
//商品不存在
const NoCommodityErrCode = 505201;
// 商品失效
const CommodityInvalid = 505202;

export default {
	components: {
		IntroList,
		GoodsInfo,
		Store,
		RichText,
		Banner,
		BlankView,
		FuncButtons,
		Merchants,
		share,
	},
	data() {
		return {
			liveId: "",
			liveStatus: "",
			liveName:"",
			id: "",
			activityTypeState: 0,
			load: false,
			brandId: "",
			isOneSku: 0,
			minShelfAmountMoney: null,
			miniAmountMoney: {},
			miniOrgAmountMoney: {},
			userDiscount: void 0,
			userDiscountStr: "",
			isFreeShipping: 0,
			isFreeTaxes: 0,
			mdseLikeNum: 0,
			userLikeMdse: 0,
			salesNum: void 0,
			name: "",
			brandName: "",
			cityName: "",
			isOverseas: false,
			supportRefund: 0,
			rankDiscountedStatus: false,
			userLevelName: "",
			userDiscountRateStr: "",
			userDiscountRate: "",
			merchandiseLimitStatus: false,
			limitNum: 0,
			ticketStatus: false,
			couponCodeStatus: 0,
			storeName: "",
			storeCountry: "",
			storeLogo: "",
			storeBg: "",
			storeId: void 0,
			storeIdOnSaleNum: void 0,
			evaluateNum: 0,
			evaluateDetail: [],
			description: "",
			merchandiseResources: [],
			videoKey: "",
			stock: 0,
			lockStock: 0,
			deleted: 0,
			showAppStatus: 0,
			shelfStatus: 0,
			collecting: false,
			merchandiseOptions: [],
			skuInfo: [],
			currentSkuId: "",
			maxSkuId: "",
			minSkuId: "",
			coverImgKey: "",
			invalid: false,
			// 秒杀活动 start
			isSecKill: 0,
			sckillStart: 0,
			seckillStartTime: 0,
			seckillEndTime: 0,
			seckillProgress: "",
			seckillActivityId: "",
			// 秒杀活动 end
			// 拼团活动 start
			isAssemble: 0,
			isAddCart: 0,
			assembleStart: 0,
			assembleStartTime: 0,
			assembleEndTime: 0,
			assemblePersonNum: 0,
			assembleProgress: "",
			assembleActivityId: "",
			showOriginActivityId: "",
			minActivityPriceMoney: {},
			assembleStatus: 0,
			activityType: 0,
			grouponActivityId: "",
			isActivityNewUser: 0,
			assembleOrgPrice: {},
			// 拼团活动 end
			showSku: false,
			showMobile: false,
			// 按钮的类型
			buttonType: "origin",
			mobileData: {
				fetchedToken: false,
				goodsSkuId: "",
				goodsBuyNum: 1,
				shoppingCartNum: 0,
				systemStatusBarHeight: 0,
			},
			CartNum: 0, // 购物车数量
			plateForm: plateForm,
			goods: this.$t("message.goods"),
			selfSupport: 0,
			lanLabel: 0,
			business: null,
			isNew: false,
			shareShow: false,
			shareDescription: "想去逛，去哪逛",
			source: 7,
            serviceFeeInfo: []
		};
	},
	created() {
		// 获取路由id
		this.id = this.$route.query.goodsId;
		this.liveId = this.$route.query.liveId || "";
		this.liveStatus = this.$route.query.liveStatus || "";
		this.liveName = this.$route.query.liveName || "";
		
		// @todo 前辈们留 下的坑。。。这个字段传的时候必须是0。但是服务端分享出来的链接里带的却是客串“inviteCode”
		if( this.$route.query.activityType !== 'inviteCode' ){
			this.activityTypeState = this.$route.query.activityType;
		}

		this.source = this.$route.query.source || 7;
		if (this.id) {
			this.$storage.set("goods_id", this.id);
			this.init();
		}
		this.$storage.set("sensor_live_id", this.$route.query.liveId || "");
	},
	computed: {
		serve() {
			const GoodsServeDictionary = {
				isOverseas: this.$t("message.goods.isOverseas"),
				isFreeShipping: this.$t("message.goods.isFreeShipping"),
				isFreeTaxes: this.$t("message.goods.isFreeTaxes"),
			};
			// 服务
			return Object.entries(GoodsServeDictionary)
				.map((item) => {
					const [key, value] = item;
					return this[key] ? value : false;
				})
				.filter(Boolean)
				.join(" I ");
		},
		drections() {
			// 说明
			return this.$t("message.goods.finalSale");
		},
		skuText() {
			// sku 文本
			if (this.mobileData.goodsSkuId) {
				const { skuAttrs } =
					this.skuInfo.find((item) => item.id === this.mobileData.goodsSkuId) ||
					{};
				const valuse = (skuAttrs || []).map((item) => {
					const obj = (this.merchandiseOptions || []).find(
						(i) => i.id === item
					);
					return (obj || {}).attributeValue;
				});

				return valuse.join(" ");
			}

			return this.$t("message.goods.skuDefaultText");
		},
		showSeckill() {
			// 是否显示秒杀活动
			return this.isSecKill;
		},
		// 秒杀、换购、拼团显示的购买按钮
		// showAssembleButton() {
		//     return this.isAssemble || this.isSecKill || this.isRepurchase
		// },
		// 秒杀、换购、拼团其中的一种状态
		activityState() {
			return this.isAssemble || this.isSecKill || this.isRepurchase;
		},
		// 秒杀、换购、拼团 -> 商品正常时购买按钮
		activityStateButton() {
			return (
				this.activityState &&
				this.stock &&
				this.showAppStatus &&
				!this.deleted &&
				this.shelfStatus
			);
		},
		// 活动开始时间
		currentActivityStartTime() {
			let time = "";
			if (this.isSecKill) {
				time = this.seckillStartTime;
			} else if (this.isAssemble) {
				time = this.assembleStartTime;
			}
			return time;
		},
		// 活动是否开始
		currentActivityStart() {
			let start = 0;
			if (this.isSecKill) {
				start = this.sckillStart;
			} else if (this.isAssemble) {
				start = this.assembleStart;
			}
			return start;
		},
		showAssemble() {
			// 是否显示拼团活动
			return this.isAssemble;
		},
		showUserDiscount() {
			// 是否展示会员折扣
			return (
				(!this.showSeckill || (this.showSeckill && !this.sckillStart)) &&
				!this.showAssemble &&
				this.rankDiscountedStatus &&
				Number(this.userDiscountRate) < 1
			);
		},
		currentActivityId() {
			return (
				(this.isAssemble && this.assembleActivityId) ||
				(this.isSecKill && this.seckillActivityId) ||
				""
			);
		},
	},
	methods: {
		init() {
			this.fetchDetail();
			this.getCartNum();
		},
		async fetchDetail() {
			// 获取商品详情
			try {
				let params = {
					merchandiseId: this.id,
					liveId: this.liveId,
				};
				if (this.activityTypeState) {
					params.activityType = this.activityTypeState;
				}
				const { code, result } = await api.get_goods_detail(params);
				if ([NoCommodityErrCode, CommodityInvalid].includes(code)) {
					// 不存在商品
					this.invalid = true;
				}
				const {
					isOneSku,
					minShelfAmountMoney,
					miniAmountMoney,
					userDiscountStr,
					userDiscount,
					miniOrgAmountMoney,
					isFreeShipping,
					isFreeTaxes,
					mdseLikeNum,
					userLikeMdse,
					salesNum,
					shareDescription,
					name,
					brandName,
					storeInfo,
					isOverseas,
					supportRefund,
					rankDiscountedStatus,
					userLevelName,
					userDiscountRateStr,
					merchandiseLimitStatus,
					limitNum,
					ticketStatus,
					couponCodeStatus,
					storeIdOnSaleNum,
					EvaluateNum,
					evaluateDetail,
					description,
					descriptionEn,
					merchandiseResources,
					videoKey,
					brandId,
					stock,
					deleted,
					showAppStatus,
					lockStock,
					shelfStatus,
					merchandiseOptions,
					skuInfo,
					maxSkuId,
					miniSkuId,
					coverImgKey,
					canSecKill,
					userDiscountRate,
					canGroupon,
					grouponActivityInfo,
					activityStock,
					selfSupport,
					lanLabel,
					business,
					netAccount,
                    categoryId,
                    categoryTwoId,
                    serviceFeeInfo = []
				} = result;
				this.lanLabel = lanLabel;

				this.netAccount = netAccount;

				const {
					endTime,
					startTime,
					limitUserNum,
					activityId,
					minActivityPriceMoney,
					grouponStatus,
					activityType,
					grouponActivityId,
					progress,
				} = grouponActivityInfo || {};

				this.shareDescription = shareDescription;
				this.shareInfo = { name, shareDescription };
				// 是否为自营商品
				this.selfSupport = selfSupport;
				// 活动类型
				this.activityType = activityType;
				// 是否是秒杀
				// 是否是秒杀
				if (canSecKill && (stock === 0 || stock < 0)) {
					// 是秒杀并且总库存小于等于0的时候显示活动结束
					this.isSecKill = 0;
				} else if (canSecKill && (activityStock < 0 || activityStock === 0)) {
					// 是秒杀并且活动库存小于等于0的时候显示活动结束
					this.isSecKill = 0;
				} else {
					// 其他时候正常显示
					this.isSecKill = canSecKill;
				}
				// 活动价格
				this.minActivityPriceMoney = minActivityPriceMoney;
				if (canSecKill) {
					//活动是否开始
					this.sckillStart = Date.now() < startTime ? 0 : 1;
					// 秒杀开始时间
					this.seckillStartTime = startTime;
					// 秒杀结束时间
					this.seckillEndTime = endTime;
					// 秒杀进度
					this.seckillProgress = progress.toString();
					// 活动id
					this.seckillActivityId = activityId;
				}
				// 是否是拼团
				this.isAssemble = canGroupon;
				if (canGroupon) {
					// 参团id
					this.grouponActivityId = grouponActivityId;
					// 成团人数
					this.assemblePersonNum = limitUserNum;
					// 拼团是否开始
					this.assembleStart = Date.now() < startTime ? 0 : 1;
					// 拼团开始时间
					this.assembleStartTime = startTime;
					// 拼团结束时间
					this.assembleEndTime = endTime;
					// 拼团的活动id
					this.assembleActivityId = activityId;
					this.showOriginActivityId = activityId;
					// 拼团结果
					this.assembleStatus = grouponStatus;
				}

				// 品牌id
				this.brandId = brandId;
				// 轮播图
				this.merchandiseResources = merchandiseResources || [];
				// 是否只有一个sku
				this.isOneSku = isOneSku;
				this.minShelfAmountMoney = minShelfAmountMoney|| null;
				// 实际价格
				this.miniAmountMoney = miniAmountMoney || {};
				// 商品折扣
				this.userDiscountStr = userDiscountStr;
				this.userDiscount = userDiscount;
				// 原始价格
				this.miniOrgAmountMoney = miniOrgAmountMoney;
				// 是否包邮
				this.isFreeShipping = isFreeShipping;
				// 是否包税
				this.isFreeTaxes = isFreeTaxes;
				// 收藏人数
				this.mdseLikeNum = mdseLikeNum;
				// 用户是否收藏
				this.userLikeMdse = userLikeMdse;
				// 总体销量
				this.salesNum = salesNum;
				// 商品title
				this.name = name;
				// 商品品牌名称
				this.brandName = brandName;
				// 发货地
				this.cityName = (storeInfo || {}).cityName;
				// 是否为海外正品
				this.isOverseas = isOverseas;
				// 是否支持退货
				this.supportRefund = supportRefund;
				// 是否享受会员折扣
				this.rankDiscountedStatus = rankDiscountedStatus;
				// 会员等级名称
				this.userLevelName = userLevelName;
				// 会员折扣
				this.userDiscountRateStr = userDiscountRateStr;
				// 会员折扣小数
				this.userDiscountRate = userDiscountRate;
				// 是否限购的状态
				this.merchandiseLimitStatus = merchandiseLimitStatus;
				// 限购数量
				this.limitNum = limitNum;
				// 能否使用优惠券
				this.ticketStatus = ticketStatus;
				// 能否使用优惠码
				this.couponCodeStatus = couponCodeStatus;
				// 店铺名称
				this.storeName = (storeInfo || {}).nameZh;
				// 店铺国家
				this.storeCountry = (storeInfo || {}).countryName;
				// 店铺logo
				this.storeLogo = ((storeInfo || {}).logo || {}).url;
				// 店铺背景图
				this.storeBg = ((storeInfo || {}).recommendImage || {}).url;
				// 店铺id
				this.storeId = (storeInfo || {}).id;
				// 店铺在售商品数
				this.storeIdOnSaleNum = storeIdOnSaleNum || 0;
				// 评论数量
				this.evaluateNum = EvaluateNum;
				// 评论内容
				this.evaluateDetail = evaluateDetail;
				this.description = descriptionEn;
				// 轮播图视频
				this.videoKey = (videoKey || {}).url;
				// 总库存
				this.stock = stock;
				// 是否删除
				this.deleted = deleted;
				// 是否显示在app
				this.showAppStatus = showAppStatus;
				// 锁定库存的数量
				this.lockStock = lockStock;
				// 是否上架
				this.shelfStatus = shelfStatus;
				// sku选项
				this.merchandiseOptions = merchandiseOptions;
				// sku
				this.skuInfo = skuInfo;
				// maxSkuId, minSkuId
				this.maxSkuId = maxSkuId;
				this.minSkuId = miniSkuId;
				// 封面图
				this.coverImgKey = (coverImgKey || {}).url;
				// 商家信息
				this.business = {id: '', name: '', headImg: {}};
                this.serviceFeeInfo = serviceFeeInfo
				this.setBusiness(business.id, business.name, business.headImg)

				if (isOneSku) {
					this.mobileData.goodsSkuId = skuInfo[0].id;
				}
				if (canGroupon) {
					// 如果是拼团，assemble-banner显示的被划掉的价格
					let assembleOrgPrice = skuInfo.filter(
						(item) => item.id === miniSkuId
					)[0].amountMoney;
					this.assembleOrgPrice = assembleOrgPrice;
				}


			let sourceList = ['正在直播','直播预告','直播回放','主播资料页','店铺详情页','banner商品','海报中商品','外链进入商品详情页']
			let _source = this.source ? sourceList[this.source] : '' ;

		let liveType = ""
        if (this.liveStatus == 1) {
          liveType = "直播预告"
        }else if(this.liveStatus == 4){
          liveType = "直播回放"
        }else if(this.liveStatus == 2){
			liveType = "正在直播"
			
		}

        await this.sa.track({
          eventId: 'merchandiseDetail',
          eventParam: {
            merchandiseId: this.id,
            merchandiseName: this.shareInfo.name,
            hostNickName: '',
            hostID: '',
            firstCategory: categoryId,
            secondCategory: categoryTwoId,
            storeId: this.storeId,
            storeName: this.storeName,
            storeLanguage: (storeInfo || {}).lanLabel==2? '中文': '英文',
            cityOfStore: (storeInfo || {}).cityName,
            countryOfStore: this.storeCountry,
            liveName: this.liveName,
            liveId: this.liveId,
            liveType: liveType,
            liveLanguage: (storeInfo || {}).lanLabel==2? '中文': '英文',
            source: _source,
            shortVIdeoId: this.videoKey
          }
        });
      } catch (e) {
				console.error("fetch goods detail:", e);
				if (e && e.code === 100000) {
					this.invalid = true;
				}
			}
			this.load = true;
    },
		setBusiness(id, nameEn, logo = {} ) {
			this.business.id = id
			this.business.name = nameEn
			this.business.logo = logo.url || require("@/assets/imgs/logo.png")
		},
		beforeDestory() {
			this.mobileData.goodsSkuId = "";
			this.mobileData.goodsBuyNum = 1;
			clearInterval(this.setKillInterval);
		},
		async navToYYB() {
			this.$yyb({ jumpType: 1, jumpId: this.id });
		},
		customerService() {
			if (this.netAccount) {
				this.$router.push({
					path: "/nimChat",
					query: { sessionId: `p2p-${this.netAccount}` },
				});

				//test
				// this.$router.push({ path: '/nimChat', query: { sessionId: 'p2p-p_10879925073565511' } })
			} else {
				// const { symbol, number } = this.miniAmountMoney;

				// let data = {
				//     goodsName: this.name,
				//     goodsId: this.id,
				//     goodsImageUrl: this.coverImgKey,
				//     goodsMoneySymbol: symbol,
				//     goodsMoneyNumber: priceSeparator(Number(number).toFixed(2)),
				//     topicId: this.liveId,
				//     url: window.location.href
				// }

				let url = window.location.href;
				let subject = this.name;
				let email = "CustomerServices@shopshopslive.com";
				api.create_short_url({ content: url }).then((res) => {
					if (res.code === 0) {
						let shortUrl = res.result;
						shortUrl = encodeURIComponent(shortUrl);

						let body = `${shortUrl}`;
						window.location.href = `mailto:${email}?subject=${subject}&body=${body}`;
					}
				});
			}
		},
		qiyuKF(data) {
			ysf("product", {
				show: 1,
				title: data.goodsName,
				desc: data.goodsId,
				picture: data.goodsImageUrl,
				note: `${data.goodsMoneySymbol} ${data.goodsMoneyNumber}`,
				url: data.url,
				success: function () {
					ysf.open();
				},
			});
		},
		async placeAnOrder(type) {
			let goods = {
				id: this.id,
				merchandiseImg: {url: this.coverImgKey},
				notice: {
					hasStock: this.stock > 0,
				},
				miniAmountMoney: this.miniAmountMoney,
				miniOrgAmountMoney: this.miniOrgAmountMoney,
				shelfAmountMoney: this.minShelfAmountMoney,
			};
			let that = this;
			this.$sku.open({
				goods,
				business: this.business,
				addCartComplete: function () {
					that.$sku.close();
					that.getCartNum();
				}
			});
		},
		// 购物车数量
		async getCartNum() {
			try {
				const { code, result } = await api.get_cart_num();
				if (!code) {
					this.CartNum = result - 0;
				}
			} catch (error) {
				console.log(error);
			}
		},
		// 单击购物车按钮
		addCart() {
			let goods = {
				id: this.id,
				merchandiseImg: {url: this.coverImgKey},
				notice: {
					hasStock: this.stock > 0,
				},
				miniAmountMoney: this.miniAmountMoney,
				miniOrgAmountMoney: this.miniOrgAmountMoney,
				shelfAmountMoney: this.minShelfAmountMoney,
			};
			let that = this;
			this.$sku.open({
				goods,
				business: this.business,
				addCartComplete: function () {
					that.getCartNum();
					that.$sku.close();
				},
			});
		},
		async myWant() {
			if (!this.userLikeMdse) {
				const { code } = await api.merchandise_like({
					merchandiseId: this.id,
				});
				if (code === 0) {
					this.userLikeMdse = 1;
					this.$toast(this.$t("message.goods.collectTip"));
					if (this.netAccount) {
						 this.$store.dispatch("sendMsg", {
							type: "text",
							scene: 'p2p',
							to: this.netAccount,
							text: this.$t("message.im.iWantMessage"),
						});
					}

					const { symbol, number } = this.miniAmountMoney;
					let data = {type:7,data:{
						title: this.name,
						linkUrl: this.id,
						imageUrl: this.coverImgKey,
						describe: symbol+priceSeparator(Number(number).toFixed(2)),
						liveId: this.liveId,
						orderNo:"",
						orderId:""
						}
					};

					this.$store.dispatch("sendMsg", {
						type: "custom",
						scene: 'p2p',
						to: this.netAccount,
						content: data,
					});
				}
			}

			this.customerService();
		},
		showShare() {
			this.$isLogin(
				function () {
					this.shareShow = true;
				}.bind(this)
			);
		},

		goBack() {
			this.$router.go(-1);
		},
	},
};
</script>
<style lang="less" scoped>
.good-detail {
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  &__body {
    flex: 1;
    width: 100%;
    overflow: auto;
  }
  &__footer {
    width: 100%;
    height: 49px;
  }
}
</style>
<style lang="less" scoped>
.banner-placeholder {
	width: 100vw;
	max-width: 375px;
	height: 0;
	padding-bottom: 100%;
}
.merchants-main {
	position: relative;
	height: 62px;
  width: 100%;
	background: #ffffff;
  overflow: hidden;
}
.merchants-box {
	position: absolute;
	top: 12px;
	left: 12px;
}
.brand {
	margin-top: 2px;
	padding: 0 24px;
	background-color: #fff;
}
.share_btn {
	position: fixed;
	top: 78px;
	right: 15px;
	width: 40px;
	height: 40px;
	z-index: 100;
}
.back {
	img {
		width: 40px;
		height: 40px;
	}
	position: fixed;
	top: 85px;
	left: 15px;
	width: 40px;
	height: 40px;
	z-index: 100;
}
</style>